module.exports = __webpack_public_path__ + "img/1561568161.c1c719f7.jpg";